import { ArrowButton, Button } from "@king-ict/eupisi-ui/components";
import { hrDate } from "@king-ict/eupisi-ui/utils";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useHistory, useLocation } from "react-router";

import StaticField from "../../components/StaticField";
import { QualificationType } from "../../models/CodeBook";
import { RoleEnum } from "../../models/User/RoleEnum";
import { useGetQualificationTypesQuery } from "../../queries/codeBookQuery";
import { useGetUserSessionQuery } from "../../queries/userQuery";
import { codebookRouteProgramType } from '../../routes/routes';
import styles from "./RequestCodeBook.module.scss";

export default function CodeBookProgramTypeDetail(): JSX.Element {
  const history = useHistory();
  const location = useLocation();
  const { t } = useTranslation();
  const { data: qualificationTypes } = useGetQualificationTypesQuery();
  const { data: userSession } = useGetUserSessionQuery();

  const userCanEditData = userSession && (userSession.roleId === RoleEnum.CASAdmin || userSession.roleId === RoleEnum.CASManager 
    || userSession.roleId === RoleEnum.ASOOManager || userSession.roleId === RoleEnum.Helpdesk);

  const programTypeQualifications = () => {
    let qualificationsMask = parseInt((location.state as any).programType.qualificationMask);
    let qualifications: string[] = [];

    const setQualificationTypeName = (id: number) => {
      let qualificationType = qualificationTypes?.find(qt => qt.id === id);
      if (qualificationType) {
        qualifications.push(qualificationType.name);
      }
    }

    if ((qualificationsMask & QualificationType.CompleteQualification) !== 0)
      setQualificationTypeName(QualificationType.CompleteQualification);

    if ((qualificationsMask & QualificationType.PartialQualification) !== 0)
      setQualificationTypeName(QualificationType.PartialQualification);

    if ((qualificationsMask & QualificationType.MicroQualification) !== 0)
      setQualificationTypeName(QualificationType.MicroQualification);

    return qualifications.join(", ");
  };

  const navigateToProgramType = () => {
    history.push(
      codebookRouteProgramType()
    );
  };

  const navigateToEditRecord = () => {
    history.push(
      codebookRouteProgramType(),
      {
        page: "edit",
        programType: (location.state as any).programType
      }
    );
  };

  return (
    <>
      <Row>
        <Col md={12}>
          <ArrowButton
            backwards
            ariaLabel=""
            onClick={navigateToProgramType}
          />
          <span className={styles.backButtonCaption}>
            {t("codeBook.navigateToCodeBook")}
          </span>

        </Col>
      </Row>
      <Row className="mt-5">
        <Col md={8}>
          <h3>{t("codeBook.programType")}</h3>
        </Col>
        {userCanEditData &&
          <Col md={4} className="d-flex justify-content-end align-items-center">
            <Button onClick={navigateToEditRecord} >
              {t("common.edit")}
            </Button>
          </Col>
        }
      </Row>
      <Row>
        <Col md={8} className="mt-5">
          <StaticField
            label={t("common.name")}
            value={(location.state as any).programType.name}
          />
        </Col>
        <Col md={4} className="mt-5">
          <StaticField
            label={t("common.dateTo")}
            value={(location.state as any).programType.dateTo ? hrDate((location.state as any).programType.dateTo) : ""}
          />
        </Col>
      </Row>
      <Row>
        <Col md={12} className="mt-5">
          <StaticField
            label={t("codeBook.qualification")}
            value={programTypeQualifications()}
          />
        </Col>
      </Row>
    </>
  );
}